(function () {
    'use strict';

    angular.module('PWAPoCApp').directive('routeStopRowUnderground', routeStopRowUnderground);

    routeStopRowUnderground.$inject = [];

    function routeStopRowUnderground() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/shared/directives/routeStopCard/route-stop-row-underground.html',
            transclude: true,
            link: link
        };

        return directive;

        function link(scope, element, attrs) {
        }
    }
})();
